module.exports = __webpack_public_path__ + "static/media/line-vertical.5586ae40.svg";